import { LegacyMigrationMessages, TranslationLegacyMigrationMessages } from "./interfaces";

export const messages: TranslationLegacyMigrationMessages = {
  [LegacyMigrationMessages.legacyMigrationTitle]: "Legacy migration",
  [LegacyMigrationMessages.legacyMigrationNotConfigured]:
    "The migration is not configured on this environment. {{problem}}",
  [LegacyMigrationMessages.legacyMigrationForbidden]:
    "You do not have access to the legacy migration. Ask whoever manages the access.",
  [LegacyMigrationMessages.legacyMigrationSessionExpired]:
    "Your session has expired. Sign in again to continue.",

  [LegacyMigrationMessages.legacyMigrationStepCustomer]: "Customer",
  [LegacyMigrationMessages.legacyMigrationStepReview]: "Review",

  [LegacyMigrationMessages.legacyMigrationChooseTitle]: "Which customer are you migrating?",
  [LegacyMigrationMessages.legacyMigrationSearchTenant]: "Search customer",
  [LegacyMigrationMessages.legacyMigrationNoTenants]: "No customer with that name.",
  [LegacyMigrationMessages.legacyMigrationTenantsUnavailable]:
    "The customer list could not be loaded.",
  [LegacyMigrationMessages.legacyMigrationInactiveTenant]: "inactive",
  [LegacyMigrationMessages.legacyMigrationStart]: "Start migration",

  [LegacyMigrationMessages.legacyMigrationReadingTitle]: "Reading the users of {{tenant}}…",
  [LegacyMigrationMessages.legacyMigrationReadingHint]:
    "We are reading the old CRM database. It takes a few seconds and nothing is changed there.",

  [LegacyMigrationMessages.legacyMigrationReviewTitle]: "{{count}} users of {{tenant}} will be migrated",
  [LegacyMigrationMessages.legacyMigrationSearchUser]: "Search e-mail or name",
  [LegacyMigrationMessages.legacyMigrationSelectAll]: "Select all",
  [LegacyMigrationMessages.legacyMigrationClearAll]: "Unselect all",
  [LegacyMigrationMessages.legacyMigrationColumnUser]: "User",
  [LegacyMigrationMessages.legacyMigrationColumnPassword]: "Password",
  [LegacyMigrationMessages.legacyMigrationColumnModules]: "Modules",
  [LegacyMigrationMessages.legacyMigrationPasswordKept]: "keeps the password (UPPERCASE)",
  [LegacyMigrationMessages.legacyMigrationPasswordReset]: "will get an e-mail",
  [LegacyMigrationMessages.legacyMigrationPasswordKeptHint]:
    "In Topcon Suite the password must be typed with its letters in UPPERCASE, as the Topcon Legado stores it.",
  [LegacyMigrationMessages.legacyMigrationPasswordWeakHint]:
    "The Topcon Legado password does not meet the Topcon Suite rules (8 to 64 characters, with letters, digits and a symbol). "
    + "The user gets an e-mail to create a new one.",
  [LegacyMigrationMessages.legacyMigrationLockNeedsKeptPassword]:
    "The lock is only available when the Topcon Legado password is kept. Without it, the user would have no access to either "
    + "system until they create the password from the e-mail.",
  [LegacyMigrationMessages.legacyMigrationNotContractedBanner]:
    "Not contracted for {{tenant}}: {{modules}}. Contract it in Tenant Manager before migrating; users who only have it "
    + "get no access.",
  [LegacyMigrationMessages.legacyMigrationNotContracted]: "not contracted by this customer — will not be granted",
  [LegacyMigrationMessages.legacyMigrationIneligibleCount]:
    "{{count}} users cannot be migrated — see why",
  [LegacyMigrationMessages.legacyMigrationBack]: "Back",
  [LegacyMigrationMessages.legacyMigrationExportList]: "Export list",
  [LegacyMigrationMessages.legacyMigrationExportListHint]:
    "Spreadsheet of the users who can be migrated, for the customer to check before the migration.",
  [LegacyMigrationMessages.legacyMigrationExportListEmail]: "E-mail",
  [LegacyMigrationMessages.legacyMigrationExportListStatus]: "Status",
  [LegacyMigrationMessages.legacyMigrationExportListLockLegacy]: "Lock Legacy",
  [LegacyMigrationMessages.legacyMigrationExportListNewLegacyPassword]: "Set a new password in the Legacy",
  [LegacyMigrationMessages.legacyMigrationConfirm]: "Migrate {{count}} users",
  [LegacyMigrationMessages.legacyMigrationConfirmAction]: "Migrate now",
  [LegacyMigrationMessages.legacyMigrationConfirmTitle]: "Confirm the migration of {{tenant}}",
  [LegacyMigrationMessages.legacyMigrationConfirmBody]:
    "{{count}} users will be created in Identity and will sign in through the Topcon login.",
  [LegacyMigrationMessages.legacyMigrationConfirmPasswords]:
    "{{count}} of them will get an e-mail to create their password. You can run this again later without duplicating anyone.",

  [LegacyMigrationMessages.legacyMigrationMigratingTitle]: "Migrating the users of {{tenant}}",
  [LegacyMigrationMessages.legacyMigrationMigratingHint]:
    "Keep this screen open until it ends. If you close it, the migration stops where it is — whoever was already migrated stays in Identity.",
  [LegacyMigrationMessages.legacyMigrationProgress]: "{{done}} of {{count}} users",
  [LegacyMigrationMessages.legacyMigrationErrorsSoFar]: "{{count}} users failed so far",
  [LegacyMigrationMessages.legacyMigrationStop]: "Stop migration",
  [LegacyMigrationMessages.legacyMigrationStopping]: "Stopping…",

  [LegacyMigrationMessages.legacyMigrationDoneTitle]: "Done! {{tenant}} has been migrated",
  [LegacyMigrationMessages.legacyMigrationDoneWithErrorsTitle]:
    "{{tenant}} was migrated, but some users failed",
  [LegacyMigrationMessages.legacyMigrationStoppedTitle]: "The migration of {{tenant}} was interrupted",
  [LegacyMigrationMessages.legacyMigrationDoneHint]:
    "Passwords kept: {{kept}} · Password e-mails sent: {{reset}}.",
  [LegacyMigrationMessages.legacyMigrationStatCreated]: "created",
  [LegacyMigrationMessages.legacyMigrationStatUpdated]: "updated",
  [LegacyMigrationMessages.legacyMigrationStatSkipped]: "unchanged",
  [LegacyMigrationMessages.legacyMigrationStatErrors]: "errors",
  [LegacyMigrationMessages.legacyMigrationExport]: "Export CSV",
  [LegacyMigrationMessages.legacyMigrationRetry]: "Run again",

  // The plural forms i18next picks from the `count` option.
  [LegacyMigrationMessages.legacyMigrationReviewTitleZero]:
    "No user selected — pick who should be migrated",
  [LegacyMigrationMessages.legacyMigrationReviewTitleOne]:
    "{{count}} user of {{tenant}} will be migrated",
  [LegacyMigrationMessages.legacyMigrationReviewTitleOther]:
    "{{count}} users of {{tenant}} will be migrated",
  [LegacyMigrationMessages.legacyMigrationIneligibleCountOne]:
    "1 user cannot be migrated — see why",
  [LegacyMigrationMessages.legacyMigrationIneligibleCountOther]:
    "{{count}} users cannot be migrated — see why",
  [LegacyMigrationMessages.legacyMigrationConfirmZero]:
    "No user selected",
  [LegacyMigrationMessages.legacyMigrationConfirmOne]:
    "Migrate 1 user",
  [LegacyMigrationMessages.legacyMigrationConfirmOther]:
    "Migrate {{count}} users",
  [LegacyMigrationMessages.legacyMigrationConfirmBodyOne]:
    "1 user will be created in Identity and will sign in through the Topcon login.",
  [LegacyMigrationMessages.legacyMigrationConfirmBodyOther]:
    "{{count}} users will be created in Identity and will sign in through the Topcon login.",
  [LegacyMigrationMessages.legacyMigrationConfirmPasswordsZero]:
    "They all keep their old CRM password. You can run this again later without duplicating anyone.",
  [LegacyMigrationMessages.legacyMigrationConfirmPasswordsOne]:
    "1 of them will get an e-mail to create their password. You can run this again later without duplicating anyone.",
  [LegacyMigrationMessages.legacyMigrationConfirmPasswordsOther]:
    "{{count}} of them will get an e-mail to create their password. You can run this again later without duplicating anyone.",
  [LegacyMigrationMessages.legacyMigrationProgressOne]:
    "{{done}} of 1 user",
  [LegacyMigrationMessages.legacyMigrationProgressOther]:
    "{{done}} of {{count}} users",
  [LegacyMigrationMessages.legacyMigrationErrorsSoFarOne]:
    "1 user failed so far",
  [LegacyMigrationMessages.legacyMigrationErrorsSoFarOther]:
    "{{count}} users failed so far",

  [LegacyMigrationMessages.legacyMigrationOutcomeCreated]: "Created",
  [LegacyMigrationMessages.legacyMigrationOutcomeUpdated]: "Updated",
  [LegacyMigrationMessages.legacyMigrationOutcomeSkipped]: "Unchanged",
  [LegacyMigrationMessages.legacyMigrationOutcomeError]: "Error",

  [LegacyMigrationMessages.legacyMigrationReasonNoEmail]: "No e-mail on the legacy record.",
  [LegacyMigrationMessages.legacyMigrationReasonNoAccessRows]: "No access at all registered on the legacy system.",
  [LegacyMigrationMessages.legacyMigrationReasonNoSsoAccess]: "Has no CRM entitlement.",
  [LegacyMigrationMessages.legacyMigrationReasonInOtherTenant]: "Already exists in Identity under another customer ({{detail}}).",
  [LegacyMigrationMessages.legacyMigrationReasonTopconStaff]: "Topcon staff account (@topconsuite.com): not migrated.",
  [LegacyMigrationMessages.legacyMigrationReasonAlreadyProvisioned]:
    "Already existed in Identity with these modules.",
  [LegacyMigrationMessages.legacyMigrationReasonNoModulesSelected]: "No module selected.",
  [LegacyMigrationMessages.legacyMigrationReasonRemovedFromSource]:
    "Removed from the legacy database after the review.",
  [LegacyMigrationMessages.legacyMigrationReasonEmailChanged]:
    "E-mail changed on the legacy database after the review (now {{detail}}).",
  [LegacyMigrationMessages.legacyMigrationReasonResetEmailFailed]:
    "Account created, but the password reset e-mail was not sent.",
  [LegacyMigrationMessages.legacyMigrationReasonProvisionFailed]: "Provisioning failed: {{detail}}",
  [LegacyMigrationMessages.legacyMigrationReasonInvalidEmail]: "E-mail missing or invalid.",
  [LegacyMigrationMessages.legacyMigrationReasonNoValidModules]: "No valid Identity module.",

  [LegacyMigrationMessages.legacyMigrationErrorForbidden]:
    "You do not have access to the legacy migration. Ask whoever manages the access.",
  [LegacyMigrationMessages.legacyMigrationErrorTenantNotFound]: "Customer not found.",
  [LegacyMigrationMessages.legacyMigrationErrorDataSourceNotConfigured]:
    "The legacy database registry is not configured on this environment.",
  [LegacyMigrationMessages.legacyMigrationErrorDataSourceNotFound]:
    "This customer has no legacy database registered.",
  [LegacyMigrationMessages.legacyMigrationErrorDataSourceUnavailable]:
    "The legacy database could not be reached.",
  [LegacyMigrationMessages.legacyMigrationErrorModuleNotContracted]:
    "The customer has not contracted every selected module.",
  [LegacyMigrationMessages.legacyMigrationErrorInvalidRequest]: "Invalid request.",
  [LegacyMigrationMessages.legacyMigrationErrorUnknown]: "The operation could not be completed.",
  [LegacyMigrationMessages.legacyMigrationErrorDataSourceAccessDenied]:
    "The Identity user does not exist or has no permission on this customer's database.",

  [LegacyMigrationMessages.legacyMigrationColumnLegacy]: "Legacy",
  [LegacyMigrationMessages.legacyMigrationLock]: "lock",
  [LegacyMigrationMessages.legacyMigrationLockAll]: "Lock the Topcon Legado for everyone",
  [LegacyMigrationMessages.legacyMigrationAlsoUses]: "also uses: {{areas}}",
  [LegacyMigrationMessages.legacyMigrationAlreadyLocked]: "already locked",
  [LegacyMigrationMessages.legacyMigrationReviewLockHint]:
    "In \"Legacy\", whoever is ticked loses the Topcon Legado password and signs in only through Identity.",
  [LegacyMigrationMessages.legacyMigrationConfirmLocks]:
    "{{count}} will lose their Topcon Legado password and sign in only through Identity. "
    + "To give access back, reset the password in the Topcon Legado.",
  [LegacyMigrationMessages.legacyMigrationConfirmLocksOne]:
    "1 will lose their Topcon Legado password and sign in only through Identity. To give access back, reset the password in the Topcon Legado.",
  [LegacyMigrationMessages.legacyMigrationConfirmLocksOther]:
    "{{count}} will lose their Topcon Legado password and sign in only through Identity. "
    + "To give access back, reset the password in the Topcon Legado.",
  [LegacyMigrationMessages.legacyMigrationLockedSummary]: "Topcon Legado passwords locked: {{count}}.",
  [LegacyMigrationMessages.legacyMigrationLockFailed]:
    "{{count}} Topcon Legado passwords could not be locked — see why in the CSV.",
  [LegacyMigrationMessages.legacyMigrationLockFailedOne]:
    "1 Topcon Legado password could not be locked — see why in the CSV.",
  [LegacyMigrationMessages.legacyMigrationLockFailedOther]:
    "{{count}} Topcon Legado passwords could not be locked — see why in the CSV.",

  [LegacyMigrationMessages.legacyMigrationLockReasonLocked]: "Topcon Legado password locked.",
  [LegacyMigrationMessages.legacyMigrationLockReasonAlreadyLocked]: "The Topcon Legado was already locked.",
  [LegacyMigrationMessages.legacyMigrationLockReasonSkippedPasswordNotKept]:
    "Not locked: the Topcon Legado password was not kept, and the user has no Topcon Suite password yet.",
  [LegacyMigrationMessages.legacyMigrationLockReasonPasswordChanged]:
    "Not locked: the password changed in the Topcon Legado during the migration.",
  [LegacyMigrationMessages.legacyMigrationLockReasonDenied]:
    "Not locked: the Identity user may not change passwords on this database.",
  [LegacyMigrationMessages.legacyMigrationLockReasonFailed]:
    "Not locked: writing to the Topcon Legado failed ({{detail}}).",

  [LegacyMigrationMessages.legacyMigrationManageAccess]: "Manage access",
  [LegacyMigrationMessages.legacyMigrationAccessTitle]: "Manage access",
  [LegacyMigrationMessages.legacyMigrationAccessSubtitle]: "Admins allowed to migrate customers from Topcon Legado to Identity.",
  [LegacyMigrationMessages.legacyMigrationAccessGrantLabel]: "Add admin",
  [LegacyMigrationMessages.legacyMigrationAccessGrant]: "Give access",
  [LegacyMigrationMessages.legacyMigrationAccessRevoke]: "Remove access",
  [LegacyMigrationMessages.legacyMigrationAccessEmpty]: "Nobody has access yet.",
  [LegacyMigrationMessages.legacyMigrationAccessGrantedBy]: "Granted by {{name}} on {{date}}",
  [LegacyMigrationMessages.legacyMigrationAccessLoading]: "Loading…",
  [LegacyMigrationMessages.legacyMigrationAccessLoadError]: "Your access could not be checked.",
  [LegacyMigrationMessages.legacyMigrationTryAgain]: "Try again",

  [LegacyMigrationMessages.legacyMigrationSelectShown]: "Select all {{count}} filtered",
  [LegacyMigrationMessages.legacyMigrationSelectShownOne]: "Select this one",
  [LegacyMigrationMessages.legacyMigrationSelectShownOther]: "Select all {{count}} filtered",
  [LegacyMigrationMessages.legacyMigrationClearShown]: "Unselect all {{count}} filtered",
  [LegacyMigrationMessages.legacyMigrationClearShownOne]: "Unselect this one",
  [LegacyMigrationMessages.legacyMigrationClearShownOther]: "Unselect all {{count}} filtered",
  [LegacyMigrationMessages.legacyMigrationFilterAll]: "All",
  [LegacyMigrationMessages.legacyMigrationFilterLeftOut]: "Left out",
  [LegacyMigrationMessages.legacyMigrationFilterOtherAreas]: "Use other areas",
  [LegacyMigrationMessages.legacyMigrationFilterOnlyCrm]: "CRM only",
  [LegacyMigrationMessages.legacyMigrationNoUsersFound]: "No users found.",
  [LegacyMigrationMessages.legacyMigrationPageRange]: "{{from}}–{{to}} of {{total}}",
  [LegacyMigrationMessages.legacyMigrationPageNext]: "Next page",
  [LegacyMigrationMessages.legacyMigrationPagePrevious]: "Previous page",
  [LegacyMigrationMessages.legacyMigrationPageGoTo]: "Go to page {{page}}",

  [LegacyMigrationMessages.legacyMigrationStaffErrorForbidden]: "You are not allowed to manage this access.",
  [LegacyMigrationMessages.legacyMigrationStaffErrorUserNotFound]: "User not found.",
  [LegacyMigrationMessages.legacyMigrationStaffErrorTargetNotAdmin]: "Only admins can receive this access.",
  [LegacyMigrationMessages.legacyMigrationStaffErrorCannotRevokeSelf]: "You cannot remove your own access.",

  [LegacyMigrationMessages.legacyMigrationStepResult]: "Result",
  [LegacyMigrationMessages.legacyMigrationInIdentity]: "already in Identity",
  [LegacyMigrationMessages.legacyMigrationInIdentityHint]: "Already in Identity. Migrating again only adds what is missing.",
  [LegacyMigrationMessages.legacyMigrationFilterInIdentity]: "Already in Identity",
  [LegacyMigrationMessages.legacyMigrationSubtitle]:
    "Bring the CRM (TopSys) users into Identity. Running it again is safe: nobody is duplicated.",
  [LegacyMigrationMessages.legacyMigrationChooseHint]: "{{count}} customers. In the review, whoever is already in Identity is marked.",
  [LegacyMigrationMessages.legacyMigrationChooseHintZero]: "No customers found.",
  [LegacyMigrationMessages.legacyMigrationChooseHintOne]: "1 customer. In the review, whoever is already in Identity is marked.",
  [LegacyMigrationMessages.legacyMigrationChooseHintOther]: "{{count}} customers. In the review, whoever is already in Identity is marked.",
  [LegacyMigrationMessages.legacyMigrationReviewHint]:
    "Untick whoever should not go; users already in Identity start unticked. Users whose Topcon Legado password meets the Topcon "
    + "Suite rules keep it, typed in UPPERCASE; the others get an e-mail to create one.",
  [LegacyMigrationMessages.legacyMigrationLeave]: "Back to start"
};
